module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_02_6DC79_1SD_GJ0.96549aef.png";